import React from 'react';
import './PageMenuItem.scss';
import { Icon, Typography } from '@design-system';

export type PageMenuItemProps = {
    title: string;
    icon: React.ReactNode;
    onClick: () => void;
    color: 'red' | 'blue' | 'yellow';
    wip?: boolean;
} & React.HTMLAttributes<HTMLDivElement>;

export const PageMenuItem: React.FC<PageMenuItemProps> = ({ title, icon, onClick, color, wip, ...props }) => {
    return (
        <div className={`page-menu-item ${wip ? 'wip' : ''}`} {...props} onClick={() => wip || onClick()} data-color={color}>
            <Icon icon={icon} size={26} color={color} variant="surrounded" iconInsetSpacing={28} />
            {wip && <Typography intrinsic="span" className='wip-tag'>En construction</Typography>}
            <Typography intrinsic="h4">{title}</Typography>
        </div>
    );
};
